module.exports = {
    // 导航栏
    navbar: {
        HOME: 'HOME',
        ABOUT: 'ABOUT',
        ABOUTUS: 'About Us',
        EDITORIAL: 'Editorial Policies',
        POLICY: 'Open Access Policy',
        NEWS: 'News',
        PAYMENT: 'APC Payment',
        JOURNALS: 'JOURNALS',
        CJOURNALS: 'Chinese Journals',
        EJOURNALS: 'English Journals',
        SPECIALISSUES: 'Special Issues',
        SPECIALISSUESINFO: 'Special Issue Details',
        BOOKS: 'BOOKS',
        ACABOOKS: 'Academic Books',
        LITABOOKS: 'Literary Works & Textbooks',
        CONTACT: 'CONTACT',
        CONFERENCE: 'CONFERENCE',
        MORE: 'MORE',
        Email: 'Email',
        Location: 'Location',
        LOGIN: 'LOGIN',
        Search: 'Search'
    },
    // 底部
    footer: {
        CONTACTUS: 'CONTACT US',
        WEBSITENAVIGATION: 'WEBSITE NAVIGATION',
        ABOUTUS: 'ABOUT US',
        OURSERVICES: 'OUR SERVICES',
        NEWS: 'NEWS',
        LIVERATE: 'LIVE RATE',
        CUSTOMERSERVICE: 'CUSTOMER SERVICE',
        WECHAT: 'WECHAT'
    },
    // 首页
    index: {
        SERVICES: 'SERVICES',
        NEWS: 'NEWS',
        GOLDMATENEWS: 'GOLDMATE NEWS',
        MARKETINSIGHT: 'MARKET INSIGHT',
        KUNDAX: 'KUNDAX',
        GOLDMATE: 'GOLDMATE',
        GOLDMATEGROUP: 'GROUP',
        KUNDAGROUP: 'GROUP'
    }
}


// WEBPACK FOOTER //
// ./src/common/lang/en.js